import React, {useEffect, useState}  from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import {     
    Table,
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    CardSubtitle,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Form,
    Button,
    Input,
    InputGroup, Container } from "reactstrap";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import { Link, useHistory} from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import axios from 'axios';
import { HRConfig, formatDate, TOAST_OPTIONS } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";



    const PIPs = () => {
        
        const [ipaList, setIpaList] = useState([])
        const [isloading, setIsloading] = useState(false)

        useEffect(() => {
            let obj = JSON.parse(localStorage.getItem("authMildUser"));
            let EmployeeNo = obj.uid;
            const CompanyID = obj.activeCompany;
              setIsloading(true)
               axios.get(`${url.PIPS_X}?$filter=EmployeeNo eq '${EmployeeNo}'&expand=ipaLines,ipaLines2,ipaLines3,ipaLines4&company='${CompanyID}'`, HRConfig).then(function(response){
                  setIpaList(response.data.value);
                setIsloading(false)
            }).catch((e)=>{
              console.log(e)
              setIsloading(false)
            })
          }, []);
     
        const history = useHistory();
        
        const handleDetails = (row) =>{ 
           
        }
        const handleFilter = () =>{
          const startDate = document.getElementsByClassName("filterDate")[0]._flatpickr.selectedDates[0]
          const endDate = document.getElementsByClassName("filterDate")[0]._flatpickr.selectedDates[1]
          const filterStatus = document.getElementsByClassName("filterStatus")[0].value
          let urlx = url.IPAS;
          
          if(filterStatus && !startDate){
            urlx = `${url.IPAS} &$filter=Status eq '${filterStatus}'`

          }
          if(!filterStatus && startDate){
            urlx = `${url.IPAS} &$filter=PostingDate ge '${formatDate(startDate)}' & PostingDAte le '${formatDate(endDate)}'`

          }
          if(filterStatus && startDate){
            urlx = `${url.IPAS} &$filter=Status eq '${filterStatus}' & PostingDate ge '${formatDate(startDate)}' & PostingDAte le '${formatDate(endDate)}'`
          }
          //console.log(url)
          axios.get(urlx, HRConfig).then(function(response){ setIpaList(response.data.value); }).catch((e)=>{console.log(e)})
         
        }
        const { SearchBar } = Search;
        const columns = [
        {
          dataField: 'No',
          text: 'Plan No',
          sort: true,
          formatter: noFormatter
        },
        {
          dataField: 'DepartmentCode',
          text: "Department",
          sort: true,
        },
        {
          dataField: 'EmployeeNo',
          text: "Employee",
          sort: true,
        },
        {
          dataField: 'Appraiser',
          text: "Appraiser",
          sort: true,
        },
        {
          dataField: 'PerformanceYear', 
          text: 'Year',
          sort: true
        }, 
        {
          dataField: 'PostingDate',
          text: 'Posting Date',
          sort: true
        },
        {
            dataField: 'PIPPhase',
            text: 'PIP Phase',
            sort: true,
            formatter: paFormatter
          },  

        {
          dataField: 'Status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];
  
        const defaultSorted = [{
          dataField: 'No',
          order: 'desc'
        }];
  
        function periodFormatter(row){
          return(
            <strong>{row.AppraisalPeriod} {row.PerformanceYear}</strong>
          )
        }
        function linesFormatter(cellContent, row){
          return(
            <strong>{row.ipaLines.length}</strong>
          )
        }
        function noFormatter(cellContent, row){
          return(
            <strong>{cellContent}</strong>
          )
        }
  
        function actionFormatter(cellContent, row){
          return(
            <>
             <Button
              type="button"
              color="info"
              className="btn-sm btn-rounded"
              onClick={() => {history.push(`/performance-improvement-plan/${row.SystemId}`)}}
            >
              Details
            </Button>
          </>
          )
        }
        function statusFormatter(cellContent, row) {
          if (row.Status == "Pending Approval") {
            return (
              <div>
                  <Badge className="me-2 bg-danger">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else if (row.Status == "Approved"){
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-warning">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        function paFormatter(cellContent, row) {
          if (row.ConvertToAppraisal == "No") {
            return (
              <div>
                  <Badge className="me-2 bg-secondary">
                  { cellContent }
                  </Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-success">
                  { cellContent }
                  </Badge>
              </div>
            );
          }
        }
        return (
            <>
                <LoadingOverlay
            active={isloading}
            spinner={<BounceLoader />}
            text='Please wait...' >
                <div className="page-content">
                    <MetaTags>
                    <title>Performance Improvement Plans | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Performance Improvement Plans" />
                        
                        <Row>
                        <Col lg={12}>
                         {/*  <Card>
                            <CardBody>
                              <CardTitle className="h5 mb-4">Filter</CardTitle>
                     
                               
                               <Row>
                                <Col lg={3}>
                                <div className="col-sm-auto">
                                    <Flatpickr
                                      className="form-control d-block filterDate"
                                      placeholder="dd M,yyyy"
                                      options={{
                                        mode: "range",
                                        dateFormat: "Y-m-d"
                                      }}
                                    />
                                </div>
                                </Col>
                                <Col lg={3}>
                                <div className="col-sm-auto">
                                  <label className="visually-hidden" htmlFor="autoSizingSelect">By Status</label>
                                  <select defaultValue="0" className="form-select filterStatus">
                                    <option value=""> Select Status </option>
                                    <option value="">All</option>
                                    <option value="Open">Open</option>
                                    <option value="Approved">Approved</option>
                                    <option value="Pending Approval">Pending Approval</option>
                                  </select>
                                </div>
                                </Col><Col lg={3}>
                                <div className="col-sm-auto">
                                  <button  className="btn btn-primary w-md" onClick={handleFilter}>Filter</button>
                                </div>
                                </Col>
                                <Col lg={3}> <div className="text-sm-end">
                                  <Link
                                    className="btn btn-success"
                                    to="/add-individual-performance-agreement"
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add IPA
                                  </Link>
                                </div></Col>
                                </Row>
                           
                            </CardBody>
                          </Card> */}
                        </Col>
                      </Row>  
                      <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <CardTitle></CardTitle>
                  <CardSubtitle className="mb-3">
                    
                  </CardSubtitle>

                 {ipaList && (ipaList.length > 0) && (
                  <ToolkitProvider
                      keyField="No"
                      data={ ipaList }
                      columns={ columns }
                      search
                    >
                      { toolkitProps => (
                          <React.Fragment>
                            <Row className='mb-5'>
                              <Col lg={8} className='mb-2'>
                                <div  className="rounded bg-light d-grid gap-2">
                                  <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                </div>
                              </Col>
                        
                              <Col lg={4}> 
                              <div className="d-grid gap-2">
                                  <Button
                                    color='primary'
                                    className="btn"
                                    onClick={() => { history.push(`/add-performance-improvement-plan`) }}
                                  >
                                    <i className="mdi mdi-plus me-1" />
                                    Add PIP
                                  </Button>
                                </div>
                              </Col>
                            </Row>
                      
                            <Row>
                              <Col xl="12">
                                <div className="table-responsive">
                            
                                <BootstrapTable 
                                  keyField='No' 
                                  data={ ipaList } 
                                  columns={ columns } 
                                  striped
                                  hover
                                  condensed
                                  bordered={ false }
                                  noDataIndication="No Records" 
                                  defaultSorted={ defaultSorted }
                                  classes={ "table align-middle table-nowrap table-check" }
                                    {...toolkitProps.baseProps}
                                  />
                             </div>
                             </Col>
                             </Row>
                             </React.Fragment>
                            
                      )
                    }
                  </ToolkitProvider>
                  

                  )}
                  {ipaList && (ipaList.length < 1) && (
                    <div className="text-center">
                      <div className="mb-4">
                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                      </div>
                      <div>
                      <h5>No Performance Improvement Plan Found</h5>
                      <p className="text-muted">
                              
                      </p>
                      </div>
                      <div className="text-center mt-4">
                          <Link
                          to="/add-performance-improvement-plan"
                          className="btn btn-primary  btn-sm"
                          >
                          Create PIP <i className="mdi mdi-arrow-right ms-1" />
                          </Link>
                      </div>
                  </div>

                  )}
                  
                </CardBody>
              </Card>
            </Col>
          </Row>


                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PIPs;